import { render } from "./TextLoader.vue?vue&type=template&id=2895be31&scoped=true"
import script from "./TextLoader.vue?vue&type=script&lang=js"
export * from "./TextLoader.vue?vue&type=script&lang=js"

import "./TextLoader.vue?vue&type=style&index=0&id=2895be31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2895be31"]])

export default __exports__